import { Household } from "../../../types/Household.types";

export const getMockHousehold: (obj?: Partial<Household>) => Household = (
  obj
) => ({
  Id: 115567,
  Customers: [
    {
      Id: 52628,
      PartnerCustomerId: null,
      Name: {
        Prefix: "Mr.",
        First: "ARLENE",
        Middle: "J",
        Last: "Candler",
        Suffix: null,
      },
      DateOfBirth: "1962-06-29T00:00:00",
      CustomerType: "PRI",
      MaritalStatus: "M",
      Gender: "M",
      Relationship: "SELF",
      Email: "1517560@test.hagerty.com",
      Phone: {
        Id: 78470,
        AreaCode: "714",
        Prefix: "897",
        Suffix: "8103",
        Extension: null,
        Type: "HOME",
        EffectiveDate: "2008-07-11T09:46:35",
        ExpirationDate: null,
        IsDefault: true,
      },
      ResidenceAddress: {
        Id: 8436353,
        LineOne: "14402 Purdy St.",
        LineTwo: "",
        City: "Westminster",
        County: "Orange",
        StateRegion: "CA",
        PostalCode: "92683-4637",
        Country: "US",
        Township: null,
        Type: "Home/Residence",
        EffectiveDate: "2008-07-10T09:46:35",
        ExpirationDate: null,
        IsDefault: false,
        IsSeasonal: false,
      },
      MailingAddress: {
        Id: 9144142,
        LineOne: "14402 Purdy St.",
        LineTwo: "",
        City: "Westminster",
        County: "Orange",
        StateRegion: "CA",
        PostalCode: "92683-4637",
        Country: "US",
        Township: null,
        Type: "Mailing",
        EffectiveDate: "2008-07-10T09:46:35",
        ExpirationDate: null,
        IsDefault: true,
        IsSeasonal: false,
      },
      DriverInfo: {
        DriversLicense:
          "AE+/hDrWgkGa7nHov4hz1gEAAABALsdC8IEX4ml4Gv8rfgURzuXqYY/IRQhseIq7Ii5nmNbgReUlBGj/41UEyboC3tJ4gIfVzVJA5gZ+NslEJSFY",
        LicensedState: "CA",
        IsVehicleOperator: true,
        YearsLicensed: 41,
        HasRegularUseVehicle: true,
        HasTickets: false,
        HasAccidentsOrClaims: false,
        IsLicensedLessThanThreeYearsIndValue: false,
        DateFirstLicensedMonth: null,
        DateFirstLicensedYear: null,
        MostUsedVehicle: null,
      },
      EntityName: "",
      InsuredType: "PRIM",
      OwnershipInterests: [],
    },
    {
      Id: 1228924,
      PartnerCustomerId: null,
      Name: {
        Prefix: "Mrs.",
        First: "EDNA",
        Middle: "",
        Last: "Candler",
        Suffix: null,
      },
      DateOfBirth: "1966-12-13T00:00:00",
      CustomerType: "SEC",
      MaritalStatus: "M",
      Gender: "F",
      Relationship: "SPOUS",
      Email: null,
      Phone: null,
      ResidenceAddress: null,
      MailingAddress: null,
      DriverInfo: {
        DriversLicense:
          "AE+/hDrWgkGa7nHov4hz1gEAAACxR0HUKVcHPGctPJ7kvwcQYcWS4x+tLgxXP6XcafHUEfm/K8vfgJKsp1ChKo97hSGi6kjMfxzcJvKR3cNMJWTE",
        LicensedState: "CA",
        IsVehicleOperator: false,
        YearsLicensed: 38,
        HasRegularUseVehicle: true,
        HasTickets: false,
        HasAccidentsOrClaims: false,
        IsLicensedLessThanThreeYearsIndValue: false,
        DateFirstLicensedMonth: null,
        DateFirstLicensedYear: null,
        MostUsedVehicle: null,
      },
      EntityName: "",
      InsuredType: "SECD",
      OwnershipInterests: [],
    },
  ],
  AccountType: "NORM",
  AccountClassification: "PERS",
  ...obj,
});
